<template>
  <NGrid class="h-full" cols="3" item-responsive responsive="screen">
    <NGridItem class="pa-2" span="3 m:2">
      <PersonalCanvases v-if="activeSelectionType === 'canvas'" />
      <CanvasTemplates v-else-if="activeSelectionType === 'canvas-template'" />
      <Sections v-else-if="activeSelectionType === 'section'" ref="sectionsRef" />
      <SectionTemplates v-else-if="activeSelectionType === 'section-template'" />
    </NGridItem>
    <NGridItem class="pa-2" span="3 m:1">
      <SectionSelectorSelected
        v-model="selectedItems"
        @clear="selectedItems = []"
        @drop="onDrop"
        @remove="onRemoveSelection"
      />
    </NGridItem>
  </NGrid>
</template>

<script setup lang="ts">
import { NGridItem, NGrid } from 'naive-ui'
import { ref } from 'vue'

import useAppStore from '@canvas-selector/stores/app'
import PersonalCanvases from './PersonalCanvases.vue'
import CanvasTemplates from './CanvasTemplates.vue'
import Sections from './Sections.vue'
import SectionTemplates from './SectionTemplates.vue'
import SectionSelectorSelected from '@canvas-builder/components/ui/SectionList/SectionSelectorSelected.vue'
import type { Canvas } from '@openapi'

const { activeSelectionType, selectedItems } = useAppStore()
const sectionsRef = ref<InstanceType<typeof Sections> | null>(null)

function onRemoveSelection(section: Canvas) {
  selectedItems.value.splice(
    selectedItems.value.findIndex((s) => s.id === section.id),
    1,
  )
}

function onDrop(dropOnItemId?: Canvas['id'], index?: number) {
  // Call the onDrop method on the Sections component
  if (sectionsRef.value && activeSelectionType.value === 'section') {
    sectionsRef.value.onDrop(dropOnItemId, index)
  }
}
</script>
